<template>
  <v-layout wrap class="reverse-on-small">
    <v-flex v-if="!hideForm" :xl4="selectedBid" md6
            :class="{'block-form-container':!signedIn}">
      <v-layout v-if="hasBids && !bid">
        <v-select
          :items="bids"
          label="Your bids"
          persistent-hint
          :error-messages="errors.first('bid')"
          data-vv-as="Bid"
          data-vv-name="bid"
          v-validate="'required'"
          :item-text="bidFormat"
          item-value="bidId"
          v-model="selectedBid">
        </v-select>
      </v-layout>
      <v-layout v-if="!hideForm" column>
        <v-flex md12>
          <v-select
            :items="filteredTruckingCompanies"
            label="Bidding Company"
            item-text="companyName"
            item-value="id"
            :error-messages="errors.first('company')"
            data-vv-as="Company Name"
            data-vv-name="company"
            v-validate="'required'"
            :disabled="disableForm || hasBids"
            v-model="bidForm.truckingCompanyId">
          </v-select>
        </v-flex>
        <v-flex md12>
          <v-select
            :items="loadsOptions"
            label="Number of Loads"
            :disabled="disableForm"
            :error-messages="errors.first('loads')"
            data-vv-as="Number of Loads"
            data-vv-name="loads"
            v-validate="'required'"
            item-text="text"
            item-value="value"
            v-model="bidForm.numberOfLoads">
          </v-select>
        </v-flex>
        <v-flex md12>
          <v-float-field v-if="ifLoadboardBiddingEnabled"
                         label="Enter your per load rate ($)"
                         :disabled="disableForm"
                         :error-messages="errors.first('bidFormRate')"
                         data-vv-as="Load rate"
                         data-vv-name="bidFormRate"
                         v-validate="'required|min_value:1'"
                         :messages="perDistanceCostMessage"
                         v-model="bidForm.bidAmount"/>
          <v-text-field v-else
                        disabled
                        :value="fixedRateLoadAmount"
                        label="per load rate ($)"></v-text-field>
        </v-flex>
        <v-flex md12  v-if="_.get(listing,'bids.placed') > 0" class="pt-1" justified>
          <span class="font-italic mt-5">(Lowest bid: ${{listing.bids.minimumBid}})</span>
        </v-flex>
        <v-flex md12>
          <date-picker
            class="bidPickup"
            input-id="pickupTimePicker"
            placeholder="Pickup Date"
            data-vv-as="Pickup Date"
            data-vv-name="pickupTimePicker"
            :disabled="disableForm"
            v-validate="'required'"
            v-model="bidForm.pickupTime">
          </date-picker>
          <div v-if="errors.first('pickupTimePicker')"
               class="v-text-field__details pt-1">
            <div class="v-messages error--text">
              <div class="v-messages__wrapper">
                <div class="v-messages__message">
                  {{errors.first('pickupTimePicker')}}
                </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <v-layout v-if="!hideForm">
        <v-flex>
          <v-textarea
            :disabled="disableForm"
            label="Questions (optional)"
            v-if="!hasBids"
            clearable
            color="secondary"
            v-model="bidForm.message">
          </v-textarea>
          <v-layout class="pb-3" justify-end>
            <v-btn class="accent mr-0"
                   v-if="!hasBids && !isDisabled"
                   :disabled="disableForm || errors.any()"
                   :loading="placeBidLoading"
                   @click="placeBid()">
              <v-icon class="pl-2" color="white">gavel</v-icon>
              Submit Bid
            </v-btn>

            <v-btn class="accent mr-0"
                   v-if="isDisabled"
                   :disabled="true">
              <v-icon class="pl-2" color="white">gavel</v-icon>
              Account Disabled
            </v-btn>

            <v-btn class="accent mr-0"
                   v-if="hasBids && !isAccepted"
                   :loading="placeBidLoading"
                   @click="cancelBid()">
              <v-icon class="pl-2" color="white">cancel</v-icon>
              <span v-if="isLoadboardBiddingEnabled">Cancel Bid</span>
              <span v-else>Revoke Availability</span>
            </v-btn>

            <v-btn class="accent mr-0"
                   v-if="hasBids && isLoadboardBiddingEnabled"
                   :disabled="disableForm || errors.any()"
                   :loading="placeBidLoading"
                   @click="updateBid()">
              <v-icon class="pl-2" color="white">gavel</v-icon>
              Update Bid
            </v-btn>

            <v-btn class="mr-0"
                   flat
                   v-if="hasBids && isAccepted"
                   :to="`/companies/${bidForm.truckingCompanyId}/booked-loads`">
              Booked Loads
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <div v-if="!signedIn"
           class="block-form-overlay">
        <v-layout column justify-center align-center fill-height>
          <v-btn class="accent" @click="$router.push({ name: 'onboard' })">
            Register now to start bidding instantly!
          </v-btn>
        </v-layout>
      </div>
    </v-flex>

    <v-flex v-if="$vuetify.breakpoint.xl && selectedBid"
            lg4 justify-center
            class="mb-2 px-2 text-xs-center">
      <bid-conversation v-if="selectedBid"
                        :disable-form="disableForm"
                        :bid-id="selectedBid">
      </bid-conversation>
    </v-flex>

    <v-flex v-if="!hideMapAndConversation"
            xs12
            :md6="!hideForm && ($vuetify.breakpoint.lgAndDown || !selectedBid)"
            :lg4="!hideForm && $vuetify.breakpoint.xl && selectedBid"
            justify-center class="mb-2 px-2 text-xs-center">
      <v-btn-toggle class="day-night-toggle mb-2"
                    v-if="selectedBid && $vuetify.breakpoint.lgAndDown"
                    mandatory
                    v-model="viewToggle">
        <v-btn flat value="map">
          <span>Map</span>
          <v-icon>map</v-icon>
        </v-btn>
        <v-btn flat value="timeline">
          <span>Conversation</span>
          <v-icon>chat</v-icon>
        </v-btn>
      </v-btn-toggle>
      <load-map
        v-show="viewToggle === 'map'"
        :disable-zoom="!signedIn"
        :origin-place-id="originPlaceId"
        :destination-place-id="destinationPlaceId">
      </load-map>
      <bid-conversation v-if="selectedBid"
                        v-show="viewToggle === 'timeline'"
                        :disable-form="disableForm"
                        :bid-id="selectedBid">
      </bid-conversation>
    </v-flex>
  </v-layout>
</template>

<script>

import _ from 'lodash';
import API from '@/api';
import * as Timestamps from '@/types/timestamp';
import { bidStatus } from '@/types';
import { mapState, mapGetters } from 'vuex';
import VFloatField from '@/components/VFloatField';
import LoadMap from '@/components/LoadMap';
import BidConversation from '@/components/BidConversation';
import DatePicker from '@/components/DatePicker';

import {
  accountHasOfficePermission,
} from '@/store/permissions';
import pluginMixin from '@/mixins/pluginMixin';
import unitsOfMeasurePlugin from '../mixins/unitsOfMeasurePlugin';

export default {
  name: 'BidForm',
  props: {
    listing: {
      type: Object,
    },
    bid: {
      type: Object,
    },
    hideForm: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideMapAndConversation: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  mixins: [
    pluginMixin,
    unitsOfMeasurePlugin,
  ],
  data: () => ({
    selectedBid: null,
    viewToggle: 'map',
    bidForm: {
      numberOfLoads: 1,
      truckingCompanyId: null,
      bidAmount: null,
      message: null,
      pickupTime: null,
      status: null,
    },
    loadsOptions: [],
    placeBidLoading: false,
    bidStatus: null,
    bidsHeaders: [
      {
        text: 'Bid Id',
        sortable: true,
        value: 'bidHumanId',
      },
      {
        text: 'Amount',
        value: 'amount',
        sortable: true,
      },
      {
        text: '',
        value: 'action',
      },
    ],
  }),
  components: {
    VFloatField,
    LoadMap,
    BidConversation,
    DatePicker,
  },
  computed: {
    _() {
      return _;
    },
    perDistanceCostMessage() {
      if (this.listing && this.bidForm.bidAmount) {
        return [`($${this.distanceRateLabel(this.bidForm.bidAmount, this.listing.trip.loadedMiles)})`];
      }
      return [];
    },
    originPlaceId() {
      return this.listing ? _.get(this.listing, 'from.googlePlaceId', null) :
        _.get(this.bid, 'listing.pickupLocation.googlePlace.placeId', null);
    },
    destinationPlaceId() {
      return this.listing ? _.get(this.listing, 'to.googlePlaceId', null) :
        _.get(this.bid, 'listing.dropoffLocation.googlePlace.placeId', null);
    },
    ...mapState('companies', {
      companies: 'companies',
      company: 'company',
    }),
    ...mapGetters('companies', [
      'truckingCompanies',
    ]),
    ...mapGetters('applications', [
      'signedIn',
    ]),
    filteredTruckingCompanies() {
      return _.reject(this.truckingCompanies, { id: _.get(this.listing,'listingCompany.companyId')});
    },
    isAccepted() {
      return this.bidStatus === bidStatus.ACCEPTED;
    },
    disableForm() {
      return !this.signedIn || this.isAccepted;
    },
    bids() {
      return this.bid ? [this.bid] : _.get(this.listing, 'bids.mine', []);
    },
    hasBids() {
      return !!this.bids.length;
    },
    companyStatus() {
      return _.get(this.company, 'accountStatus');
    },
    companyDisabledSince() {
      return _.get(this.companyStatus, 'disabledSince');
    },
    isDisabled() {
      return !_.isEmpty(this.companyDisabledSince);
    },
    fixedRateLoadAmount() {
      const fixedAmount = _.get(this.listing, 'fullPriceRate');
      return _.get(this.listing, 'amount', fixedAmount);
    },
  },
  watch: {
    bid() {
      this.selectedBid = this.bid.id;
    },
    selectedBid() {
      this.loadBid(this.selectedBid);
    },
    bids() {
      if (!this.selectedBid) {
        this.selectedBid = _.head(this.bids).bidId;
      }
    },
  },
  methods: {
    ...mapGetters('profiles', [
      'findCompanyAccount',
    ]),
    loadBid(bidId) {
      API.bid.getBid({ bidId }).then((response) => {
        const bidData = response.data;

        this.bidForm.truckingCompanyId = bidData.truckingCompany.companyId;
        this.bidForm.bidAmount = bidData.amount;
        this.bidForm.numberOfLoads = bidData.numberOfLoads;
        this.bidForm.pickupTime = bidData.pickupTime;
        this.bidStatus = bidData.status;

        const loadsCount = _.get(bidData, 'listingBids.availableLoadCount', null);
        if (loadsCount) {
          _.range(1, loadsCount + 1).forEach((i) => {
            this.loadsOptions.push({ value: i, text: i });
          });
        }
      });
    },
    bidFormat(item) {
      const companyName = _.get(item, 'companyName', '');
      return `$ ${item.amount} - ${companyName}`;
    },
    hasOfficePermission(listing) {
      const companyId = _.get(listing, 'listingCompany.id', null);
      return accountHasOfficePermission(this.findCompanyAccount()(companyId));
    },
    async cancelBid() {
      const confirmation = await this.$confirm('Do you really want to cancel this bid?');
      if (!confirmation) {
        return;
      }

      window.__insp.push(['tagSession', 'cancel_bid']);
      this.$ga.event({
        eventCategory: 'bid',
        eventAction: 'cancel-bid',
      });

      this.placeBidLoading = true;
      try {
        await API.bid.deleteBid({ bidId: this.selectedBid });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Bid Canceled',
        });

        this.$emit('refresh');
      } catch (error) {
        window.__insp.push(['tagSession', 'cancel_bid_error']);
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later',
        });
      } finally {
        this.placeBidLoading = false;
      }
    },
    async updateBid() {

      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.placeBidLoading = true;
        try {
          const { bidAmount, numberOfLoads, pickupTime } = this.bidForm;

          this.$ga.event({
            eventCategory: 'bid',
            eventAction: 'update-bid',
            eventLabel: 'update-bid',
            eventValue: bidAmount,
          });

          window.__insp.push(['tagSession', 'update_bid']);

          await API.bid.updateBid({
            bidId: this.selectedBid,
            body: {
              status: this.bidStatus,
              bidAmount,
              numberOfLoads,
              pickupTime: Timestamps.localizedPickerTimestamp(pickupTime),
            },
          });

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Bid Updated',
          });

          this.$emit('refresh');
        } catch (error) {
          window.__insp.push(['tagSession', 'update_bid_error']);
          this.$store.dispatch('applications/setErrorNotification', {
            message: 'An error occurred, please try again later',
          });
        } finally {
          this.placeBidLoading = false;
        }
      }
    },
    async placeBid() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.placeBidLoading = true;
        try {
          const { bidAmount, message, numberOfLoads, pickupTime, truckingCompanyId } = this.bidForm;
          this.$ga.event({
            eventCategory: 'bid',
            eventAction: 'place-bid',
            eventLabel: 'place-bid',
            eventValue: bidAmount,
          });

          window.__insp.push(['tagSession', 'place_bid']);

          await API.bid.placeBid({
            bidAmount,
            message,
            numberOfLoads,
            pickupTime: Timestamps.localizedPickerTimestamp(pickupTime),
            truckingCompanyId,
            loadListingId: this.listing.listingHumanId,
          });

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Bid placed',
          });

          this.$emit('refresh');
        } catch (error) {
          window.__insp.push(['tagSession', 'place_bid_error']);
          this.$store.dispatch('applications/setErrorNotification', {
            message: 'An error occurred, please try again later',
          });
        } finally {
          this.placeBidLoading = false;
        }
      }
    },
  },
  created() {
    if (this.bid) {
      this.selectedBid = this.bid.id;
    } else {
      if (this.hasBids) {
        this.selectedBid = _.head(this.bids).bidId;
      } else if (this.filteredTruckingCompanies.length) {
        this.bidForm.truckingCompanyId = this.filteredTruckingCompanies[0].id;
      }

      const pickupTime = _.get(this.listing, 'from.pickupWindow.pickupAt', false);
      if (pickupTime) {
        this.bidForm.pickupTime = pickupTime;
      }
      // eslint-disable-next-line
      _.range(1, _.get(this.listing, 'bids.availableLoadCount', 10) + 1).forEach((i) => {
        this.loadsOptions.push({ value: i, text: i });
      });
    }

    if (!this.isLoadboardBiddingEnabled){
      this.bidForm.bidAmount = this.fixedRateLoadAmount;
    }
  },
};
</script>

<style>
  .vdatetime.bidPickup {
    width: 100%;
  }

  .bid-date-picker {
    padding-bottom: 5px;
    margin-top: 19.5px;
  }

  @media (max-width: 960px) {
    .reverse-on-small {
      flex-direction: column-reverse;
    }
  }

  .timeline-section {
    height: 350px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/BidForm.vue